import React from 'react';

import _ from 'lodash';

import {Field, reduxForm} from 'redux-form';
import classNames from 'classnames';

import FormField from 'components/FormField';
import {DateField} from 'components/Fields';
import Label from 'components/Label';
import ErrorBlock from 'components/ErrorBlock';
import Warning from 'components/Warning';

import {validDate} from 'utils/validators';
import {formatDateForApi} from 'utils/datetime';

import {recordBreakClauseNotice} from 'ducks/tenancy';

import './styles.css';

const formSubmit = (
  values,
  dispatch,
  {tenancyId, warnings, getSuccessExtraActions, getFailureExtraActions}
) => {
  const data = {
    ...values,
    tenancyId,
    givenDate: formatDateForApi(values.givenDate),
    departureDate: formatDateForApi(values.departureDate)
  };

  if (warnings) {
    data.warnings = warnings.meta;
  }

  const successExtraActions = getSuccessExtraActions();
  const failureExtraActions = getFailureExtraActions();

  dispatch(
    recordBreakClauseNotice(data, successExtraActions, failureExtraActions)
  );
};

const BreakClauseNoticeRecordForm = ({
  className,
  handleSubmit,
  error,
  warnings
}) => {
  return (
    <div>
      {error && <ErrorBlock>{error}</ErrorBlock>}
      {warnings &&
        warnings.data._warning && (
          <Warning>{_.get(warnings, 'data._warning')}</Warning>
        )}
      <form
        onSubmit={handleSubmit}
        className={classNames(className, 'BreakClauseNoticeRecordForm')}>
        <FormField>
          <Label>NOTICE GIVEN DATE</Label>
          <Field
            name="givenDate"
            validate={[validDate]}
            fieldWarning={_.get(warnings, 'data.givenDate')}
            component={DateField}
          />
        </FormField>
        <FormField>
          <Label>DEPARTURE DATE</Label>
          <Field
            name="departureDate"
            validate={[validDate]}
            fieldWarning={_.get(warnings, 'data.departureDate')}
            component={DateField}
          />
        </FormField>
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'breakClauseNoticeRecord',
  onSubmit: formSubmit,
  enableReinitialize: true
})(BreakClauseNoticeRecordForm as React.ComponentType<
  any
>) as React.ComponentType<any>;
